<template>
    <div class="companyThought_wrap">
      <Header/>
      <section class="warp">
        <div class="title">
          <span class="line_left line">
            <img :src="leftImg">
          </span>
          <h3>公司理念</h3>
          <span class="line_right line">
            <img src="../assets/goldRight.png">
          </span>
        </div>
        <div class="content">
          <p>
            资本市场风云变幻，盈融达投资秉承“稳健、进取”的风格，通过多样的盈利模式，在复杂的市场中为客户追求资产的稳健增长, 盈融达通过对风险的控制和把握，为客户寻找稳健与进取的黄金平衡，让用户能够放心买入，安心持有。

          </p>
        </div>
      </section>
      <Footer/>
    </div>
</template>
<script>
  import Header from './header'
  import leftImg from '../assets/goldLeft .png'
  import Footer from './footer'
    export default {
        name: 'companyThought',
        components: {
          Header,
          Footer
        },

        props: {},

        data() {
            return {
              leftImg,
            }
        },

        computed: {},

        watch: {},

        created() {
        },

        mounted() {
        },

        destroyed() {
        },

        methods: {}
    }
</script>

<style scoped lang="scss">
.companyThought_wrap{
  height: 100%;
  .warp{
    padding-top: 5.625rem;
    width: 40%;
    height: 80%;
    margin: auto;
    .title{
      text-align: center;
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
    .line_left,.line_right{
      display: inline-block;
      position: absolute;
      top: 50%;
    }
    .line{
      width: 75px;
      height: 20px;
      line-height: 20px;
      margin-top: -10px;
    }
    h3{
      display: inline-block;
      color: #555;
      text-align: center;
    }
    img{
      width: 100%;
      vertical-align: middle;
    }
    }
    .content{
      color: #666;
      text-align: justify;
    }
  }
}
@media screen and (min-width: 768px) {
  .line_left{
    left: 60px;
  }
  .line_right{
    right: 60px;
  }
  .line{
    width: 75px;
    height: 20px;
    line-height: 20px;
    margin-top: -10px;
  }
  h3{
    font-size: 30px;
    margin: 70px 50px;
  }

  .content{
    text-align: justify;
    -ms-text-justify: inter-ideograph;
    text-justify: inter-ideograph;
    text-spacing: ideograph-alpha;
    font-size: 14px;
    line-height: 32px;
    text-indent: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companyThought.vue